import toastrError from 'src/helpers/toastr/toastrError';
import toastrSuccess from 'src/helpers/toastr/toastrSuccess';
import { wtsApi } from 'src/api';
export var CompensationsActions;
(function (CompensationsActions) {
    CompensationsActions["GET_COMPENSATIONS_REQUEST"] = "GET_COMPENSATIONS_REQUEST";
    CompensationsActions["GET_COMPENSATIONS_SUCCESS"] = "GET_COMPENSATIONS_SUCCESS";
    CompensationsActions["GET_COMPENSATIONS_FAIL"] = "GET_COMPENSATIONS_FAIL";
    CompensationsActions["POST_COMPENSATIONS_REQUEST"] = "POST_COMPENSATIONS_REQUEST";
    CompensationsActions["POST_COMPENSATIONS_SUCCESS"] = "POST_COMPENSATIONS_SUCCESS";
    CompensationsActions["POST_COMPENSATIONS_FAIL"] = "POST_COMPENSATIONS_FAIL";
    CompensationsActions["DELETE_COMPENSATIONS_REQUEST"] = "DELETE_COMPENSATIONS_REQUEST";
    CompensationsActions["DELETE_COMPENSATIONS_SUCCESS"] = "DELETE_COMPENSATIONS_SUCCESS";
    CompensationsActions["DELETE_COMPENSATIONS_FAIL"] = "DELETE_COMPENSATIONS_FAIL";
})(CompensationsActions || (CompensationsActions = {}));
export function getCompensationsRequest() {
    return { type: CompensationsActions.GET_COMPENSATIONS_REQUEST };
}
export function getCompensationsSuccess(compensations) {
    return { type: CompensationsActions.GET_COMPENSATIONS_SUCCESS, payload: compensations };
}
export function getCompensationsFail() {
    return { type: CompensationsActions.GET_COMPENSATIONS_FAIL };
}
export function postCompensationsRequest() {
    return { type: CompensationsActions.POST_COMPENSATIONS_REQUEST };
}
export function postCompensationsSuccess(compensation) {
    return { type: CompensationsActions.POST_COMPENSATIONS_SUCCESS, payload: compensation };
}
export function postCompensationsFail() {
    return { type: CompensationsActions.POST_COMPENSATIONS_FAIL };
}
export function deleteCompensationsRequest() {
    return { type: CompensationsActions.DELETE_COMPENSATIONS_REQUEST };
}
export function deleteCompensationsSuccess(ProductId) {
    return { type: CompensationsActions.DELETE_COMPENSATIONS_SUCCESS, payload: ProductId };
}
export function deleteCompensationsFail() {
    return { type: CompensationsActions.DELETE_COMPENSATIONS_FAIL };
}
export async function getCompensation(id) {
    try {
        const { data } = await wtsApi.v2.compensationGetDetail(id);
        return data.Data;
    }
    catch (e) {
        toastrError(e);
        return null;
    }
}
export function getCompensations(params) {
    return (dispatch) => {
        dispatch(getCompensationsRequest());
        return wtsApi.v2.compensationSearchList(params)
            .then(({ data }) => {
            const result = data.Data;
            dispatch(getCompensationsSuccess(result));
        })
            .catch((error) => {
            console.error(error);
            dispatch(getCompensationsFail());
            toastrError(error);
        });
    };
}
export function postCompensations(params) {
    return (dispatch) => {
        dispatch(postCompensationsRequest());
        return wtsApi.v2.compensationCreateUpdateCreate(params)
            .then(({ data }) => {
            const result = data.Data;
            dispatch(postCompensationsSuccess(result));
            toastrSuccess();
            return result;
        })
            .catch((error) => {
            console.error(error);
            dispatch(postCompensationsFail());
            toastrError(error);
            return null;
        });
    };
}
export function deleteCompensation(params) {
    return (dispatch) => {
        dispatch(deleteCompensationsRequest());
        return wtsApi.v2.compensationDeleteDelete(params)
            .then(({ data }) => {
            const result = data.Data;
            dispatch(deleteCompensationsSuccess(params?.Id));
            toastrSuccess();
            return result;
        })
            .catch((error) => {
            console.error(error);
            dispatch(deleteCompensationsFail());
            toastrError(error);
            return null;
        });
    };
}
